<div *ngIf="showData">
  <div class="questionnaire-wrapper" *ngIf="sections.length > 0 || questionnairesList.length > 0">
    <div class="d-flex justify-content-end me-4">
      <div *ngIf="!isCustomer">
        <mat-icon class="text-secondary mt-2 pt-1 me-4" matTooltip="Locked" (click)="markLock(false)" *ngIf="lock">lock</mat-icon>
        <mat-icon class="text-gray-A3 mt-2 pt-1 me-4" matTooltip="Unlocked" (click)="markLock(true)" *ngIf="!lock">lock_open</mat-icon>

        <mat-icon class="text-secondary  mt-2 pt-1 me-4" matTooltip="Marked as Done" (click)="markDone(false)" *ngIf="done">check_circle</mat-icon>
        <mat-icon class="text-gray-A3  mt-2 pt-1 me-4" matTooltip="Mark as Done" (click)="markDone(true)" *ngIf="!done">check_circle</mat-icon>
        <mat-icon class="text-gray-A3  mt-2 pt-1 me-4" matTooltip="Export to Word" (click)="exportToWord()">file_download</mat-icon>
        <!--<mat-icon class="text-gray-A3  mt-2 pt-1 me-4" matTooltip="Download Questionnaire" (click)="downloadQsPdf()">file_download</mat-icon>-->
      </div>
      <div *ngIf="isCustomer">
        <mat-icon class="text-secondary mt-2 pt-1 me-4" matTooltip="Locked" *ngIf="lock">lock</mat-icon>
      </div>
      <mat-form-field class="fs-7 me-3" *ngIf="!user.isCustomer && questionnairesList.length > 0">
        <mat-label>Questionnaire*</mat-label>
        <mat-select [(ngModel)]="questionnaireId" (selectionChange) ="onQuestionnaireChange($event)">
          <mat-option *ngFor="let list of questionnairesList"
                      [value]="list.id">{{list.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="fs-7 w-10">
        <mat-label>Year*</mat-label>
        <mat-select [(ngModel)]="questionnaireBucket" (selectionChange) ="onRecurringChange($event)">
          <mat-option *ngFor="let filter of recurringFilters"
                      [value]="filter.key">{{filter.key}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-tab-group class="px-3 flex-grow-1 mt-n2" color="accent" animationDuration="0ms"
                   [selectedIndex]="selectedIndex" (selectedIndexChange)="changeSelectedIndex($event)" [ngClass]="customerQuestionnaires ? 'customer-questionnaires' : ''">
      <mat-tab *ngFor="let tab of sections; let index = index" [label]=tab.name>
        <ng-template matTabContent>
          <app-dynamic-form class="mt-2"
                            [questions]="tab.questions || []"
                            [userId]="userId"
                            [org]="org"
                            [clientId]="clientId"
                            [questionnaireId]="questionnaireId"
                            [questionnaireName]="questionnaireName"
                            [questionnaireBucket]="questionnaireBucket"
                            [questionnaireBucketValue]="questionnaireBucketValue"
                            [sectionObj]="tab"
                            [sections]="sections"
                            [sectionIndex]="index"
                            [s3Credentials]="s3Credentials"
                            [uploadBucket]="uploadBucket"
                            [lock]="lock"
                            [isCustomer]="isCustomer"
                            (saveQs)="updateQsAnswers($event)"
                            appInvalidControlScrollContainer>
          </app-dynamic-form>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="d-flex justify-content-center mt-5" *ngIf="sections.length === 0 && questionnairesList.length === 0 && !isCustomer">
    No Questionnaires Added.
  </div>
</div>
